import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    beneficiaryFlowSubtitle:
      'This information is required to open a pro Shine account for the company {legalName} of which you are the beneficial owner',
    beneficiaryFlowTitle: 'Complete your information',
    cta: {
      reamainingSteps: '{numberOfRemainingSteps} more steps',
      reamainingStepsSingular: '1 more step',
      send: 'Submit my application',
    },
    errorSubtitle:
      'Please go back on the steps highlighted in red to finalize your application.',
    subtitle: 'Upload your documents and send your application.',
    title: 'Your application',
    titleWithLegalName: 'Your application for {legalName}',
  },

  fr: {
    beneficiaryFlowSubtitle:
      'Ces informations sont obligatoires pour l’ouverture du compte pro Shine pour l’entreprise {legalName} dont vous êtes le bénéficiaire effectif',
    beneficiaryFlowTitle: 'Complétez vos informations',
    cta: {
      reamainingSteps: 'Encore {numberOfRemainingSteps} étapes',
      reamainingStepsSingular: 'Encore une étape',
      send: 'Envoyer mon dossier',
    },
    errorSubtitle:
      'Veuillez revenir sur les étapes indiquées en rouge afin de finaliser votre dossier.',
    subtitle: 'Ajoutez vos documents et envoyer votre dossier.',
    title: 'Votre dossier',
    titleWithLegalName: 'Votre dossier pour {legalName}',
  },
} as const);
